import { usePlayer } from "@/context/PlayerContext";
import { Play, Pause, X } from "lucide-react";

const fmt = (s) => {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60), sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, "0")}`;
};

export default function AudioPlayer() {
  const { current, playing, progress, duration, toggle, seek, pendingNext, cancelAutoPlay } = usePlayer();
  if (!current) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-ink/95 backdrop-blur-xl border-t border-hotpink/40" data-testid="global-audio-player">
      {pendingNext && (
        <div className="max-w-7xl mx-auto px-3 md:px-10 pt-2 pb-1 flex items-center gap-3 border-b border-hotpink/30" data-testid="autoplay-next-overlay">
          <span className="font-outfit font-extrabold uppercase tracking-widest text-[10px] text-hotpink">up next</span>
          <span className="font-outfit text-white text-sm md:text-base truncate flex-1">
            Pt. {pendingNext.part} — {pendingNext.title}
          </span>
          <span className="font-outfit text-white/60 text-xs" data-testid="autoplay-countdown">
            playing in {pendingNext.countdown}s
          </span>
          <button
            onClick={cancelAutoPlay}
            data-testid="autoplay-cancel"
            aria-label="Cancel auto-play"
            className="text-white/60 hover:text-hotpink transition-colors"
          >
            <X size={14} />
          </button>
        </div>
      )}
      <div className="max-w-7xl mx-auto px-3 md:px-10 py-2 md:py-3 flex items-center gap-3 md:gap-4">
        <button
          onClick={toggle}
          data-testid="player-toggle"
          className="w-10 h-10 md:w-12 md:h-12 bg-hotpink hover:bg-hotpink_dark flex items-center justify-center text-white shadow-[2px_2px_0px_#FFFFFF] md:shadow-[3px_3px_0px_#FFFFFF] hover:shadow-[5px_5px_0px_#FFFFFF] transition-all flex-shrink-0"
        >
          {playing ? <Pause size={18} fill="white"/> : <Play size={18} fill="white"/>}
        </button>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-2 md:gap-3 mb-1">
            <span className="scribble text-hotpink text-base md:text-lg" data-testid="player-ep-num">Ep. {current.number}</span>
            <span className="font-outfit font-semibold text-white truncate text-sm md:text-base" data-testid="player-ep-title">{current.title}</span>
          </div>
          <div className="flex items-center gap-2 md:gap-3">
            <span className="text-[10px] md:text-xs text-white/50 font-mono w-8 md:w-10">{fmt(progress)}</span>
            <input
              type="range"
              className="audio-range flex-1"
              min={0}
              max={duration || 0}
              value={progress}
              onChange={(e) => seek(parseFloat(e.target.value))}
              data-testid="player-scrubber"
            />
            <span className="text-[10px] md:text-xs text-white/50 font-mono w-8 md:w-10 text-right">{fmt(duration)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
